<template>
    <div>
      <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-dialog
        persistent
        max-width="850px"
        v-model="dialog"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">İki Tarih Arası Fişlerde Hesap Değiştirme</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="referansbirlestir">
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <blockquote>
                         İki Tarih Arası Fişlerde Hesap Değiştirme İşlemi Yapılacaktır. İşleme Devam Edilmesini İstiyor musunuz..?
                         </blockquote>
                       
                      </v-flex>
                     
                    </v-layout>
                    <v-layout row wrap>
                    
                     
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="OldAccountingCode"
                    :controlValue="OldAccountingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    text='Eski Hesap Kodu'
                    @validateCheck="checkAccoutingValidate()"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="NewAccountingCode"
                    :controlValue="NewAccountingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    text='Yeni Hesap Kodu'
                   
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
               
              
                 <v-flex xs12 sm12 md12>
                        <tarihcomp
                          etiket="Başlangıç Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="DateStart"
                        >
                        </tarihcomp>
                      </v-flex>
                       <v-flex xs12 sm12 md12>
                       <tarihcomp
                          etiket="Bitiş Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="DateEnd"
                        >
                        </tarihcomp>
                      </v-flex>
                      
                      <v-flex xs12 sm12 md6>
                        <v-text-field
                  label="Şifre"
                  v-model="Password"
                  single-line
                   type="password"
                   pattern="[0-9]*" 
                   inputmode="numeric"
                ></v-text-field>
                      </v-flex>
             
              </v-layout>
                   
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="close()">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary darken-1" text @click.native="makeChange()">
              {{ 'Değiştir' }}
            </v-btn>
          
          </v-card-actions>
        </v-card>
      </v-dialog>
  
     
    </div>
  </template>
  
  <script>
 
  import auth from "../../../../../api/auth";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  import catimuhasebekodu from "../../comp/catimuhasebekodu.vue";
 import tarihcomp from "@/components/app/customcomp/tarihim";
  export default {
    data() {
      return {
        OldAccountingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
     NewAccountingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
        Password:null,
        DateStart:null,
        DateEnd:null,
       
        dovizsayristir:0,
        seciliCariFirma:null,
        seciliMuhasebeFirma:null,
        dialog: false,
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "İşlem Yapılıyor.."
      };
    },
    components: {
      catimuhasebekodu,
      loadingcomp,
      snackbarcomp,
      tarihcomp
    },
    methods: {
      checkAccoutingValidate()
      {

      },
        close()
        {
           this.dialog=false;
        },
      makeChange() {
       
        this.loadingvmodel = true
        let Params = {
         
          CompanyID : this.credentials.MuhasebeSirketNo,
          UserID:this.credentials.UserID,
          OldAccountingCode:this.OldAccountingCode.Code,
          NewAccountingCode:this.NewAccountingCode.Code,
          DateStart:this.DateStart,
          DateEnd:this.DateEnd,
          
      };
          this.$http.post(auth.API_URL + 'api/AccountingParameters/AccountingCodeChange', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
  
            this.loadingvmodel = false
            this.text1 =  response.body.ResponseMessage;
            this.snackbar =true;
  
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service-'
              this.snackbar =true;
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service-'
              this.snackbar =true;
              this.loadingvmodel = false
            }
          })
        
         
          this.controlDialog = false;
          this.dialog=false;
      },
      open() {
        this.dialog = true;
      },
     
    },
  };
  </script>
  
  <style>
  </style>
  